import {
	ApiUtils,
	_axios
} from '@/api/apiUtil.js';
import constant from '@/util/constant.js';
const api = {
	list: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/xueli/fapiao/list", params, successCallback, failCallback, exceptionCallback);
	},
	save: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.postLoadingAjax(constant.serverUrl + "/xueli/fapiao/save", params, successCallback, failCallback, exceptionCallback);
	},
	toUpdate: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/xueli/fapiao/toDetails", params, successCallback, failCallback, exceptionCallback);
	},
	update: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.putLoadingAjax(constant.serverUrl + "/xueli/fapiao/update", params, successCallback, failCallback, exceptionCallback);
	},
	remove: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.deleteLoadingAjax(constant.serverUrl + "/xueli/fapiao/remove", params, successCallback, failCallback, exceptionCallback);
	},
	update1: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.putLoadingAjax(constant.serverUrl + "/xueli/fapiao/update1", params, successCallback, failCallback, exceptionCallback);
	},
	toUpload: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.putLoadingAjax(constant.serverUrl + "/xueli/fapiao/toUpload", params, successCallback, failCallback, exceptionCallback);
	},
	upload: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.postLoadingAjax(constant.serverUrl + "/xueli/fapiao/upload", params, successCallback, failCallback, exceptionCallback);
	},
	toDetail: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.putLoadingAjax(constant.serverUrl + "/xueli/fapiao/toDetail", params, successCallback, failCallback, exceptionCallback);
	}, mergeFP: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.postLoadingAjax(constant.serverUrl + "/xueli/fapiao/mergeFP", params, successCallback, failCallback, exceptionCallback);
	},
	sendEmail: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/xueli/fapiao/sendFapiaoEmail", params, successCallback, failCallback, exceptionCallback);
	},
}

export default api;
